import React, { useState } from 'react'

const TextMasked = ({ value, type = "text" }) => {
    const [visible, setVisible] = useState(false);
      const maskValue = (val) => {
    if (!val) return "";

    if (type === "email") {
      const [name, domain] = val.split("@");
      if (!name || !domain) return val;

      const visiblePart = name.slice(0, 1);
      const maskedPart = "*".repeat(name.length - 1);
      return `${visiblePart}${maskedPart}@${domain}`;
    }

    if (type === "phone") {
      return val.slice(0, 2) + "****" + val.slice(-2);
    }

    return val;
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span>{visible ? value : maskValue(value)}</span>

      <button
        type="button"
        onClick={() => setVisible(!visible)}
        style={{
          border: "none",
          background: "transparent",
          cursor: "pointer"
        }}
      >
        <i className={`fa ${visible ? "fa-eye-slash" : "fa-eye"}`} />
      </button>
    </div>
  )
}

export default TextMasked